import { render } from "./Theform.vue?vue&type=template&id=3fa4b462"
import script from "./Theform.vue?vue&type=script&lang=js"
export * from "./Theform.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__